<div class="m-auto p-3" style="min-height: 70vh;">
  <header class="d-flex align-items-center">
    <mat-icon (click)="exitCrudCase()">chevron_left</mat-icon>
    <h1 *ngIf="!saveCase">Nuevo <strong>Caso</strong></h1>
    <h1 *ngIf="saveCase">{{currentEntity.patientFullName}}</h1>
  </header>
  <ng-container>
    <div class="d-flex justify-content-center" *ngIf="!saveCase">
      <!-- MULTI STEPPER -->
      <mat-stepper orientation="{{size700_1020 ? 'vertical' : 'horizontal'}}" #stepper [selectedIndex]="selectedStepIndex"  class="w-100 h-100">
        <!-- 4 PASOS PRINCIPALES - CRUDCASESTEPSARRAY -->
        <mat-step *ngFor="let step of crudCaseStepsArray; let i = index" [label]="step.name" >
          <div *ngIf="!loading">
            <router-outlet *ngIf="i === selectedStepIndex"></router-outlet>
          </div>

          <ng-container class="d-flex w-100" *ngIf="loading">
            <app-loading class="m-auto"></app-loading>
          </ng-container>
          
          <div class="d-flex justify-content-center gap-4" *ngIf="!loading">

            <!-- STEPPER NAVIGATION BUTTONS -->
            <!-- PATIENT -->
            <ng-container *ngIf="stackRoutes.length == 0 && !loading">
              <button mat-button class="mybutton button secondary-button" appDebounceClick (debounceClick)="onSelectPatient()" [debounceTime]="700" *ngIf="!loading">Detalles del paciente<mat-icon>chevron_right</mat-icon></button>
            </ng-container>

            <ng-container *ngIf="stackRoutes.length == 1 && !loading">
              <div class="container">
                <div class="row gy-4 text-center">
                  <div class="col-12 col-sm-6 text-center text-md-end">
                    <button mat-button class="button secondary-button" (click)="onPreviousStep(true)" *ngIf="!notCompleted && patientId==0"><mat-icon>chevron_left</mat-icon>Seleccionar / Crear paciente</button>
                  </div>
                  <div class="col-12 col-sm-6 text-center text-md-start">
                    <button mat-button class="mybutton button secondary-button" appDebounceClick (debounceClick)="onSetPatient()" [debounceTime]="700" [disabled]="!havePatientId" *ngIf="!loading">Registros dentales<mat-icon>chevron_right</mat-icon></button>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- CASE FILE -->
            <ng-container *ngIf="stackRoutes.length == 2 && !loading">
              <div class="container">
                <div class="row gy-4 text-center">
                  <div class="col-12 col-sm-6 text-center text-md-end">
                    <button mat-button class="button secondary-button" (click)="onGetBackToPatientDetail()"><mat-icon>chevron_left</mat-icon> Datos del paciente </button>
                  </div>
                  <div class="col-12 col-sm-6 text-center text-md-start">
                    <button mat-button class="button secondary-button" appDebounceClick (debounceClick)="onNextStep()" [debounceTime]="700" [disabled]="!isCompositeFormValid && !isPhotographyFormValid">Radiografías/Archivos STL <mat-icon>chevron_right</mat-icon></button>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="stackRoutes.length == 3 && !loading">
              <div class="container">
                <div class="row gy-4 text-center">
                  <div class="col-12 col-sm-6 text-center text-md-end">
                    <button mat-button class="button secondary-button" (click)="onPreviousStep()"><mat-icon>chevron_left</mat-icon> Fotografías/Composite </button>
                  </div>
                  <div class="col-12 col-sm-6 text-center text-md-start">
                    <button mat-button class="button secondary-button" appDebounceClick (debounceClick)="onNextStep()" [debounceTime]="700" [disabled]="!isSTLFormValid">Prescripción <mat-icon>chevron_right</mat-icon></button>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- PRESCRIPTION -->
            <ng-container *ngIf="stackRoutes.length > 3 && stackRoutes.length < 13">
              <div class="container">
                <div class="row gy-4 text-center">
                  <div class="col-12 col-sm-6 text-center text-md-end">
                    <button mat-button class="button secondary-button" (click)="onPreviousStep()"><mat-icon>chevron_left</mat-icon>{{ stackRoutes.length == 4 ? 'Radiografías/Archivos STL' : 'Paso anterior'}} </button>
                  </div>
                  <div class="col-12 col-sm-6 text-center text-md-start">
                    <button [disabled]="disabledButtonStages()" *ngIf="!showConfirmButton" data-testid="goNextStep" mat-button class="button secondary-button" appDebounceClick (debounceClick)="onNextPrescriptionStep()" [debounceTime]="700">{{ stackRoutes.length == 12 ? 'Generar documento' : 'Guardar y Continuar'}}<mat-icon>chevron_right</mat-icon></button>
                    <button *ngIf="showConfirmButton" data-testid="goConfirmCase" mat-button class="button secondary-button" appDebounceClick (debounceClick)="onNextStep()" [debounceTime]="700">Confirmar Caso <mat-icon>chevron_right</mat-icon></button>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- CONFIRM CASE -->
            <ng-container *ngIf="stackRoutes.length == 13">
              <div class="container">
                <div class="row gy-4 text-center">
                  <div class="col-12 col-sm-6 text-center text-md-end">
                    <button mat-button class="button secondary-button" (click)="onPreviousStep(); showConfirmButton = false"><mat-icon>chevron_left</mat-icon>Prescripción</button>
                  </div>
                  <div class="col-12 col-sm-6 text-center text-md-start">
                    <button [disabled]="disabledButtonStages()" data-testid="goSaveCase" mat-button class="btn-success button secondary-button mx-auto" (click)="onConfirmCase()">Continuar <mat-icon>check</mat-icon></button>
                  </div>
                </div>
              </div>
            </ng-container>

          </div>
        </mat-step>

      </mat-stepper>
    </div>
  </ng-container>
</div>
